import type { ModelTreeItem } from "../model-tree.type";
import type { ModelKey } from "@/modules/model/model.type";

export const getModelIconKey = (item: ModelTreeItem): ModelKey => {
  const { data, parent } = item;

  if (data.type === "location" && parent?.type === "location") {
    return "sector";
  }

  return data.type;
};
